import {IMediaDetails} from '../model/mediaDetails';
import {SortMetric} from '../constants/Constants';
import dayjs from 'dayjs';
import logging from '../service/logging';

const sortMediaByDate = (media: IMediaDetails[], descending: boolean, isCollectionMedia: boolean): IMediaDetails[] => {
   const mediaSort = (a: IMediaDetails, b: IMediaDetails): number => {
      const aSortDateTime = isCollectionMedia ? dayjs(a.AddedToGroupDateTime) : dayjs(a.SharedDateTime);
      const bSortDateTime = isCollectionMedia ? dayjs(b.AddedToGroupDateTime) : dayjs(b.SharedDateTime);
      if (aSortDateTime.isSame(bSortDateTime)) {
         return 0;
      }

      if (descending) {
         return aSortDateTime.isAfter(bSortDateTime) ? -1 : 1;
      }

      return aSortDateTime.isAfter(bSortDateTime) ? 1 : -1;
   };

   return media.sort(mediaSort);
};

const sortMediaByTitle = (media: IMediaDetails[], descending: boolean): IMediaDetails[] => {
   const mediaSort = (a: IMediaDetails, b: IMediaDetails): number => {
      const aTitle = a.Title.toUpperCase();
      const bTitle = b.Title.toUpperCase();
      if (aTitle === bTitle) {
         return 0;
      }

      if (descending) {
         return aTitle > bTitle ? -1 : 1;
      }
      return aTitle > bTitle ? 1 : -1;
   };

   return media.sort(mediaSort);
};

const sortMediaByViewCount = (media: IMediaDetails[], descending: boolean): IMediaDetails[] => {
   const mediaSort = (a: IMediaDetails, b: IMediaDetails): number => {
      if (a.ViewCount === b.ViewCount) {
         return 0;
      }

      if (descending) {
         return a.ViewCount > b.ViewCount ? -1 : 1;
      }
      return a.ViewCount > b.ViewCount ? 1 : -1;
   };

   return media.sort(mediaSort);
};

export const sortMedia = (media: IMediaDetails[], sortMetric: SortMetric, isCollectionMedia?: boolean): IMediaDetails[] => {
   if (sortMetric === SortMetric.dateAscending) {
      return sortMediaByDate(media, false, isCollectionMedia);
   } else if (sortMetric === SortMetric.dateDescending) {
      return sortMediaByDate(media, true, isCollectionMedia);
   } else if (sortMetric === SortMetric.titleAscending) {
      return sortMediaByTitle(media, false);
   } else if (sortMetric === SortMetric.titleDescending) {
      return sortMediaByTitle(media, true);
   } else if (sortMetric === SortMetric.viewsDescending) {
      return sortMediaByViewCount(media, true);
   } else if (sortMetric === SortMetric.viewsAscending) {
      return sortMediaByViewCount(media, false);
   }

   // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
   logging.error(`Attempted to sort media by unknown sortMetric: ${sortMetric}`);
   return media;
};
